import * as main            from "../main";
import * as timeinterval    from "../timeinterval";
import * as grid from "../grid";


let LABEL_ETooManyDays = "";
let dateTimeErrorMessageLabel = "";

function getGroupId(): number | null {

    const ddl = $("#DDL_Group").data("kendoDropDownList");

    if (ddl != null && ddl != undefined && ddl.value() != '') {
        return Number(ddl.value());
    }

    return null;
}

function getUserId(): number | null {

    const ddl = $("#DDL_User").data("kendoDropDownList");

    if (ddl != null && ddl != undefined && ddl.value() != '') {
        return Number(ddl.value());
    }

    return null;
}

function getTimeInterval(): number | null {
    const ddl = $("#TimeIntervalID").data("kendoDropDownList");

    if (ddl != null && ddl != undefined && ddl.value() != '') {
        return Number(ddl.value());
    }

    return null;
}

function getOccupancyState(): number | null {
    const ddl = $("#DDL_ChangeToOccupancyState").data("kendoDropDownList");

    if (ddl != null && ddl != undefined && ddl.value() != '') {
        return Number(ddl.value());
    }

    return null;
}


export function initialize(ETooManyDays: string, dateTimeErrorMessage: string): void {

    LABEL_ETooManyDays = ETooManyDays;
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    main.setHideDivBootstrap("periodSelector", false);
    grid.loadGridOptions("SearchResultOccupancyStateLogGrid");
    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("errorMessage", false);

    const selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
    const from = timeinterval.getBeginPeriodSelection(selectedInterval, null);
    const to = timeinterval.getEndPeriodSelection(selectedInterval, null);

    if (from != null && to != null) {
        const grid = $("#SearchResultOccupancyStateLogGrid").data("kendoGrid");
        if (grid != null && grid != undefined) {
            grid.pager.dataSource.page(1);
            grid.dataSource.read();
        }
    }
    else {
        $("#SearchButtonLoader").hide();
        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

export function getAdditionalData(): { groupId: number, userId: number, timestampFrom: Date, timestampTo: Date, changeToOccupancyStateID: number } {
    const groupid = getGroupId();
    const userid = getUserId();
    const interval = getTimeInterval();

    let changeToOccupancyStateId = -2;
    let fromLocal = timeinterval.getBeginPeriodSelection(interval, null);
    let toLocal = timeinterval.getEndPeriodSelection(interval, null);

    const tsDays = (toLocal.getTime() - fromLocal.getTime()) / (1000 * 3600 * 24);
    if (tsDays < 0 || tsDays >= 33) {

        // make a message
        main.setHideDiv("DivLblTooMany", true);

        var lblEmsg = $("#LblTooMany");
        if (lblEmsg != null && lblEmsg != undefined) {
            lblEmsg.text(LABEL_ETooManyDays);
        }

        fromLocal = toLocal = new Date(Date.now());
    }

    changeToOccupancyStateId = getOccupancyState(); 

    return {
        groupId: groupid,
        userId: userid,
        timestampFrom: fromLocal,   // fromDT,
        timestampTo: toLocal,       // toDT,
        changeToOccupancyStateID: changeToOccupancyStateId
    };
}
